var measurementTypes = [
  { "name": "SquareMeters", "label": "متر مربع", value: 0 },
  { "name": "Pack", "label": "بسته", value: 1 },
  { "name": "HdfSheet", "label": "ورق اچ‌دی‌اف", value: 2 },
  { "name": "sheet", "label": "شیت", value: 3 },
  { "name": "Pallet", "label": "پالت", value: 4 },
  { "name": "Tile", "label": "تایل", value: 5 },
  { "name": "Roll", "label": "رول", value: 6 },
  { "name": "kilogram", "label": "کیلوگرم", value: 7 },
  { "name": "Meter", "label": "متر", value: 8 },
  { "name": "Number", "label": "عدد", value: 9 },
];

export default measurementTypes;
